import React, { useEffect, useState } from 'react';
import { guideSteps } from '../data/guideSteps';
const navItems = [...guideSteps.map(step => ({
  id: step.id,
  number: step.number,
  title: step.title
})), {
  id: 'aktuelle-investeringer',
  number: '',
  title: 'Aktuelle investeringer'
}, {
  id: 'nyhedsbrev',
  number: '',
  title: 'Få nye lån på mail'
}];
export function StepNav() {
  const [activeId, setActiveId] = useState<string>(navItems[0].id);
  useEffect(() => {
    const sections = navItems.map(item => document.getElementById(item.id)).filter((el): el is HTMLElement => el !== null);
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (visible) setActiveId(visible.target.id);
    }, {
      rootMargin: '-20% 0px -65% 0px',
      threshold: 0
    });
    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, []);
  return <div className="sticky top-0 z-30 hidden border-y border-ink/10 bg-canvas/85 backdrop-blur md:block" data-id="element-123" data-mp="t0vuz647xvwr">
      <nav aria-label="Spring til trin" className="mx-auto flex w-full max-w-7xl items-center gap-1 overflow-x-auto px-6 py-3 lg:px-10" data-id="element-124" data-mp="12x8q88fewhtm">
        {navItems.map(step => {
        const isActive = step.id === activeId;
        return <a key={step.id} href={`#${step.id}`} aria-current={isActive ? 'true' : undefined} className={['whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-150 ease-smooth focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand', isActive ? 'bg-forest text-white' : 'text-muted hover:bg-ink/5 hover:text-ink'].join(' ')} data-id="element-125" data-mp="1bw3w1jejnpwe">
              {step.number && <span className="mr-2 tabular-nums opacity-60" data-id="element-126" data-mp="1xruciudzxnfc">
                  {step.number}
                </span>}
              {step.title}
            </a>;
      })}
      </nav>
    </div>;
}